namespace GeniuzPOS.ReportMasterData {
    export interface Report_1101Row {
        PluCode?: string;
        PluDesc?: string;
        SkuCode?: string;
        SupplierId?: string;
        SupplName?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat2Code?: string;
        SubCat1Name?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        StkUnit?: string;
        SellUnitRatio?: number;
        SellUnit?: string;
        MinStockQty?: number;
        MaxStockQty?: number;
        PurLeadTime?: number;
        SellUnitPrice1?: number;
        SellUnitPrice2?: number;
        SellUnitPrice3?: number;
        SellUnitPrice4?: number;
        SellUnitPrice5?: number;
        SellUnitPrice6?: number;
        VatType?: string;
        VatCode?: string;
        SupplItemCode?: string;
        ProductType?: number;
        CreateDate?: string;
        CreateBy?: string;
        ActiveFg?: boolean;
    }

    export namespace Report_1101Row {
        export const idProperty = 'PluCode';
        export const nameProperty = 'PluCode';
        export const localTextPrefix = 'ReportMasterData.Report_1101';
        export const deletePermission = '1POSBASE:รายงาน:ทะเบียน:สินค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:ทะเบียน:สินค้า:View';
        export const readPermission = '1POSBASE:รายงาน:ทะเบียน:สินค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:ทะเบียน:สินค้า:View';

        export declare const enum Fields {
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            SkuCode = "SkuCode",
            SupplierId = "SupplierId",
            SupplName = "SupplName",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat2Code = "SubCat2Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            StkUnit = "StkUnit",
            SellUnitRatio = "SellUnitRatio",
            SellUnit = "SellUnit",
            MinStockQty = "MinStockQty",
            MaxStockQty = "MaxStockQty",
            PurLeadTime = "PurLeadTime",
            SellUnitPrice1 = "SellUnitPrice1",
            SellUnitPrice2 = "SellUnitPrice2",
            SellUnitPrice3 = "SellUnitPrice3",
            SellUnitPrice4 = "SellUnitPrice4",
            SellUnitPrice5 = "SellUnitPrice5",
            SellUnitPrice6 = "SellUnitPrice6",
            VatType = "VatType",
            VatCode = "VatCode",
            SupplItemCode = "SupplItemCode",
            ProductType = "ProductType",
            CreateDate = "CreateDate",
            CreateBy = "CreateBy",
            ActiveFg = "ActiveFg"
        }
    }
}
